export const buildEntityLink = ({ id, baseUrl, type }: { id: string | undefined; baseUrl: string | undefined; type: string | undefined }) => {
  if (!baseUrl) {
    return;
  }
  if (!id) {
    return baseUrl;
  }

  let entityUrl = baseUrl;
  if (type) {
    entityUrl = entityUrl.replace("<ENTITY_TYPE>", type);
  }
  entityUrl = entityUrl.replace("<ENTITY_ID>", id);

  if (!entityUrl.includes(id)) {
    return `${entityUrl}/${id}`;
  }
  return entityUrl;
};
